import { Tooltip } from "src/ui/shared/Tooltip";
import { makeStyles } from "tss-react/mui";

import { List, ListSubheader, Theme } from "@mui/material";

import { useDrawerContext } from "./Drawer";

const useStyles = makeStyles()((theme: Theme) => ({
    listWithoutSubheader: {
        paddingTop: 0,
    },
    tooltip: { width: "100%", height: 30 },
    subHeader: {
        fontSize: 12,
        textTransform: "uppercase",
        color: theme.palette.emteria.text.secondary,
        lineHeight: "100%",
        marginTop: theme.spacing(2.5),
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
    },
}));

type Props = {
    title?: string;
};

export const ListWithSubHeader = (props: React.PropsWithChildren<Props>) => {
    const { classes } = useStyles();
    const context = useDrawerContext();
    const showSubheader = Boolean(props.title) && context.open;

    return (
        <List
            className={showSubheader ? undefined : classes.listWithoutSubheader}
            subheader={
                showSubheader ? (
                    <Tooltip className={classes.tooltip} title={props.title} placement="right">
                        <ListSubheader className={classes.subHeader} disableSticky>
                            {props.title}
                        </ListSubheader>
                    </Tooltip>
                ) : undefined
            }
        >
            {props.children}
        </List>
    );
};
